export default "__VITE_ASSET__gH$r9zlK__"